import React from "react";
import "./DocsPlansOverview.css";

const DocsPlansOverview = () => {
  return (
    <div className="docs-plans-container">
      <h1>Pricing</h1>
      <p className="docs-plans-intro">
        This page provides an overview of our subscription plans. Choose the
        plan that best fits your team size, usage requirements, and automation needs.
      </p>

      <h2>Subscription Plans Overview</h2>
      <p>
        Start small, go live fast, and upgrade as your team adds channels,
        assistants, and automations.
      </p>

      <section className="docs-plan-section">
        <h3>Starter</h3>
        <p className="docs-plan-description">
          For getting your first assistant live.
        </p>
        <p className="docs-plan-price">
          <strong>$11/month</strong> (billed annually) or $14 billed monthly
        </p>
        <ul>
          <li>1 teammate</li>
          <li>1,000 conversations per month</li>
          <li>1 assistant</li>
          <li>10M knowledge characters</li>
        </ul>
      </section>

      <section className="docs-plan-section">
        <h3>Professional</h3>
        <p className="docs-plan-description">
          For growing teams and multiple assistants.
        </p>
        <p className="docs-plan-price">
          <strong>$30/month</strong> (billed annually) or $37 billed monthly
        </p>
        <ul>
          <li>2 teammates</li>
          <li>3,000 conversations per month</li>
          <li>2 assistants</li>
          <li>50M knowledge characters</li>
        </ul>
      </section>

      <section className="docs-plan-section">
        <h3>Advanced</h3>
        <p className="docs-plan-description">
          For automation and heavier usage.
        </p>
        <p className="docs-plan-price">
          <strong>$179/month</strong> (billed annually) or $224 billed monthly
        </p>
        <ul>
          <li>5 teammates</li>
          <li>12,000 conversations per month</li>
          <li>100M knowledge characters</li>
        </ul>
      </section>

      <section className="docs-plan-section">
        <h3>Enterprise</h3>
        <p className="docs-plan-description">
          For security, scale, and custom requirements.
        </p>
        <p className="docs-plan-price">
          <strong>Custom pricing</strong>
        </p>
        <ul>
          <li>Custom teammates and conversation limits</li>
          <li>Custom knowledge size</li>
          <li>Dedicated support and rollout assistance</li>
          <li>Security and compliance options</li>
        </ul>
        <p>
          Contact our sales team for tailored pricing and deployment support.
        </p>
      </section>
    </div>
  );
};

export default DocsPlansOverview;
